import { DEMO_NAV, PRODUCTION_NAV } from '../config/navigation';
import { PLATFORM_NAV } from '../config/platformNavigation';

/** Extra titles for routes not covered (or needing clearer labels) in nav configs. */
const EXTRA_TITLES: Array<{ path: string; title: string }> = [
  { path: '/settings/payment-modes', title: 'Payment modes' },
  { path: '/settings/audit', title: 'Tenant audit log' },
  { path: '/settings/customers/new', title: 'New customer' },
  { path: '/settings/rate-master', title: 'Contract Master' },
  { path: '/settings/customers', title: 'Customer master' },
  { path: '/settings/vendors', title: 'Vendor master' },
  { path: '/settings', title: 'Settings' },
  { path: '/notifications', title: 'Notifications' },
  { path: '/my-trips', title: 'My trips' },
  { path: '/billing', title: 'Invoices' },
  { path: '/onboarding', title: 'Workspace setup' },
  { path: '/company-setup', title: 'Company setup' },
  { path: '/dispatch', title: 'Dispatch board' },
  { path: '/reports/commercial', title: 'Commercial Analytics' },
  { path: '/planning/requisitions', title: 'Material Dispatch Queue' },
  { path: '/planning/approvals', title: 'Approval inbox' },
  { path: '/planning/auctions', title: 'Vendor quotes' },
  { path: '/dockets', title: 'Dockets' },
  { path: '/fleet', title: 'Fleet' },
  { path: '/analytics', title: 'Operations Analytics' },
  { path: '/platform/tenants/new', title: 'Create Tenant' },
  { path: '/platform/tenants', title: 'Tenants' },
  { path: '/platform/analytics', title: 'Platform Analytics' },
  { path: '/platform/audit', title: 'Audit Log' },
  { path: '/platform/settings', title: 'Platform Settings' },
  { path: '/platform', title: 'Platform Dashboard' },
  { path: '/upload-test', title: 'Document upload test' },
  { path: '/demo/live-tracking', title: 'Live Tracking' },
  { path: '/demo/vehicle-capacity', title: 'Vehicle Capacity' },
  { path: '/demo/dock-scheduling', title: 'Dock Scheduling' },
  { path: '/demo/gate-pass', title: 'Gate Pass' },
  { path: '/demo', title: 'Demo Workspace' },
];

function collectNavTitles(): Array<{ path: string; title: string }> {
  const map = new Map<string, string>();

  const add = (path: string, title: string) => {
    const clean = path.split('?')[0].replace(/\/$/, '') || '/';
    if (!map.has(clean)) map.set(clean, title);
  };

  for (const section of PRODUCTION_NAV) {
    for (const item of section.items) add(item.path, item.name);
  }
  for (const section of DEMO_NAV) {
    for (const item of section.items) add(item.path, item.name);
  }
  for (const item of PLATFORM_NAV) {
    add(item.path, item.path === '/platform' ? 'Platform Dashboard' : item.name);
  }
  for (const entry of EXTRA_TITLES) add(entry.path, entry.title);

  return Array.from(map.entries())
    .map(([path, title]) => ({ path, title }))
    .sort((a, b) => b.path.length - a.path.length);
}

const TITLE_ENTRIES = collectNavTitles();

/**
 * Resolve a human page title from the current pathname.
 * Longest matching route prefix wins (supports detail pages under a parent route).
 */
export function resolvePageTitle(pathname: string): string {
  const path = pathname.split('?')[0].replace(/\/$/, '') || '/';

  for (const entry of TITLE_ENTRIES) {
    if (path === entry.path || path.startsWith(`${entry.path}/`)) {
      return entry.title;
    }
  }

  if (path.startsWith('/platform')) return 'Platform';
  if (path.startsWith('/demo')) return 'Demo Workspace';
  return 'Gati Sutra';
}
